<template>
    <div class="page-common-header">
        <div class="hd-top">
            <div class="wp">
                <div class="left">
                    <div class="logo-top">
                        <a href="#/home" class="logo">
                            <img src="@/assets/img/logo.png" alt="">
                        </a>
                        <div class="line"></div>
                        <div class="tel">
                            <h3>400-185-8866</h3>
                            <p>客服热线（工作日 8:30-17:30)</p>
                        </div>
                    </div>
                    <div class="logo-bot">
                        专业的实验室用品服务平台
                    </div>
                </div>
                <div class="right"
                     :class="{show:showNav}"
                >
                    <div class="search-mod">
                        <el-select v-model="searchtype" @change="searchtypeChange">
                            <el-option label="所有类型" :value="1"></el-option>
                            <el-option label="中文名称" :value="2"></el-option>
                            <el-option label="英文名称" :value="3"></el-option>
                            <el-option label="CAS号" :value="4"></el-option>
                            <el-option label="产品编号" :value="5"></el-option>
                        </el-select>
                        <div class="input-box">
                            <el-input @input="keyInput" :onkeyup="onkeyup" v-model="search" :placeholder="placeholder" @keydown.enter.native="jianting($event)" clearable></el-input>
                        </div>
                        <div class="btn" @click="jumpTo('/SearchResult')">搜商品</div>
                    </div>
                    <div class="link">
                        <a href="#/customerService/quickOrdering">
                            <img src="@/assets/img/hd-i1.png" alt="">
                            <span>快速订购</span>
                        </a>
                        <a href="javascript:;" @click="gopage('账户','/vip')">
                            <img src="@/assets/img/hd-i2.png" alt="">
                            <span>账户</span>
                        </a>
                        <a href="javascript:;" @click="gopage('购物车','/Cart')">
                            <img src="@/assets/img/hd-i3.png" alt="">
                            <span>购物车</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <div class="hd-nav"
            :class="{show:showNav}"
        >
            <div class="wp">
                <div class="all">
                    <div class="all-tit" @click="jumpTo('/SearchResult',{id:'1'})">
                        <span>全部产品</span>
                        <img src="@/assets/img/i-menu.png" alt="">
                    </div>

                    <div v-if="showType" class="all-menu">
                        <div class="all-menu-item" v-for="(item,index) in typeTreeList" :key="index">
                            <div class="title" @click="jumpTo('/SearchResult',item)">
                                <span class="flex1 text_hidden2">{{ item.name }}</span>
                                <i></i>
                            </div>
                            <div class="all-menu-children" style="left: calc(100%) !important;">
                                <div class="row" v-if="item.children" v-for="(item1,index1) in item.children" :key="index1">
                                    <div class="tit" @click.stop="jumpTo('/SearchResult',item1)">{{ item1.name }}</div>
                                    <i v-if="item1.children"></i>
                                    <div class="link" v-if="item1.children">
<!--                                        -->
                                        <a @click.stop="jumpTo('/SearchResult',item2)" href="javascript:;" v-for="(item2,index2) in item1.children" :key="index2">{{item2.name}}</a>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="nav">
                  <div class="item" :class="menuindex===index?'active':''" v-for="(item,index) in menulist" :key="index" @click="gomenu(item,index)">
                    {{ item.name }}
                  </div>

                </div>
            </div>
        </div>

        <div class="menuBtn"
             @click="showNav = !showNav"
            :class="{open:showNav}"
        ></div>

    </div>
</template>

<script>
import {goodstypeTree} from "@/api/home"
import Bus from "@/utils/bus"
import jquery from '@/utils/jquery.js'

export default {
    name: "page-common-header",
    data() {
        return {
            searchtype: 1,
            search: '', // 搜索关键字
            placeholder:'中文名/英文名/CAS NO./产品编号',
            onkeyup:'', // 输入校验 仅数字
            showNav:false,
            menulist:[
              {name:'首页',path:'/home'},
              {name:'关于一方',path:'/about'},
              {name:'品牌中心',path:'/Brand'},
              {name:'产品资讯',path:'/ProductInfo'},
              {name:'MSDS/COA',path:'/MSDSCOA'},
              {name:'新闻中心',path:'/News'},
              {name:'积分商城',path:'/integralMall'},
				// {name:'购物帮助',path:'/help/registerAndLogin'},
				{name:'购物帮助',path:'/help/service'},
              {name:'联系我们',path:'/ContactUs'},
            ],
          menuindex:0,
            typeTreeList:[], // 全部分类 树形

            showType:true,

            isfocus:false, // 搜索框是否获取焦点

        }
    },
	watch:{
    	// 监听路由
		'$route'(val){
			this.renderCur(val)
		}
	},
    created() {
        window.addEventListener('keydown', this.handkeyCode, true)//开启监听键盘按下事件
    },
    beforeDestroy() {
        window.removeEventListener('keydown', this.handkeyCode, true)//移除监听键盘按下事件监听
    },
  mounted(){
      Bus.$on("keyword", (info) => { // 接收搜索关键词
          console.log(info)
          this.search=info
	      this.$store.commit('seachKeyword', info)
      })
	  if(sessionStorage.getItem("seachKeyword")){
		  this.$store.commit('seachKeyword', sessionStorage.getItem("seachKeyword"))
		  this.search=this.$store.state.seachKeyword
	  }
	  console.log('vuex的搜索字段',this.$store.state.seachKeyword)
    this.getgoodstypeTree() // 获取全部分类
      this.renderCur(this.$route) // 菜单选中
  },
    methods:{
        // 监听失去焦点或按下回车
        jianting(event){
            console.log('触发回车并失去焦点',event);
            event.target.blur()
            this.jumpTo('/SearchResult') //搜索
        },
        // 回车和空格键提交右侧信息
        handkeyCode(e) {
            // console.log(e); // 打印出按键后的信息
            if (e.keyCode === 13 && this.isfocus) {
                console.log('触发了回车');
                this.jumpTo('/SearchResult') //搜索
            }
        },
        // 监听输入类型
        searchtypeChange(e){
          console.log('输入类型',e)
            if(e==1){ // 所有类型
                this.onkeyup=''
                this.placeholder='中文名/英文名/CAS NO./产品编号'
            }else if(e==2){ //
                this.onkeyup=''
                this.placeholder='请输入中文名'
            }else if(e==3){ //
                this.onkeyup=''
                this.placeholder='请输入英文名'
            }else if(e==4){ //
                this.onkeyup=''
                this.placeholder='请输入CAS号'
            }
            else if(e==5){ //
                this.onkeyup=''
                this.placeholder='请输入产品编号'
            }
            else{}
        },

		gopage(name,path){
			// 需判断是否有token并且未过期
			if(localStorage.getItem('Token') && !this.$utils.isTokenExpired()){
				this.$router.push({path:path})
			}else{
				Bus.$emit('re-login', '未登录')
			}
		},
		renderCur:function (route) {
			let Index=''
			this.menulist.map((item,index) => {
                // console.log(route.path,item.path)
                if (item.path == route.path){
					Index=index
			    }
			})
			this.menuindex=Index
		},

        gomenu(item,index){
		    if(this.menuindex!==index){
                this.menuindex=index
                this.$router.push(item.path)
            }

        },
        // 监听输入
        keyInput(e){
            console.log(e)
	        this.$store.commit('seachKeyword', e)
	        Bus.$emit('keywords1', {keywords:e})
        },
        jumpTo:function (path,item) {
            // console.log(this.$route)
            this.showType=!this.showType
            setTimeout(()=>{ // 关闭分类选择
                this.showType=!this.showType
            },500)

            if(path!=this.$route.path){ // 如果当前路由不是搜索页
                if(!this.search && !item){
                    this.$message({
                      type: 'warning',
                      message: "输入搜索内容",
                      duration: 2000
                    });
                    return
                }
                if(this.search){ // 点击搜索按钮
                    console.log('搜索类型',this.searchtype)
                    if(!this.checkSeach()) return
                    let seachInfo = {
                        current: 1,
                        checkedList1: [], // 分类id
                        checkedList2: [], // 品牌id
                        checkedList3: [], // 规格
                        checkedList4: [], // 货期
                    }
                    this.$store.commit('seachInfo', seachInfo)
                    this.$router.push({path,query: {keywords:this.search, searchtype:this.searchtype}})
                }
                if(item){ // 点击产品分类
                    this.$router.push({path,query: {typeid:item.id}})
                }
            }else{
                // console.log('又走一遍？')
				if(this.search){ // 点击搜索按钮
                    if(!this.checkSeach()) return
					Bus.$emit('keywords', {keywords:this.search , searchtype:this.searchtype})
				}
				if(item){ // 点击产品分类
					Bus.$emit('keywords', {typeid:item.id})
				}
            }
        },
        // 校验搜索内容
        checkSeach(){
            // this.search
            if(true){
                // this.$message({
                //     type: 'warning',
                //     message: "输入正确的搜索内容",
                //     duration: 2000
                // });
                return true
            }else{
                return false
            }
        },


        //  -------------------------接口请求
        getgoodstypeTree(){ // 获取全部分类 树形图
            goodstypeTree('').then((res) => {
              if (res.data.code==200) {
                this.typeTreeList=res.data.data
              }else{
                // this.$message({
                //   type: 'error',
                //   message: "登录失败",
                //   duration: 2000
                // });
              }

            })
        },

    }
}
</script>

<style lang="scss">
.page-common-header .hd-nav .wp .nav .item{
  font-size: 15px !important;
  cursor: pointer;
}
.page-common-header .hd-nav .wp .nav .item:hover {
  font-weight: bold;
  color: #ea6100;
}
.page-common-header .input-box .el-input__inner{
    border: none !important;
}

</style>
